var _module_exports = "<div class=\"sf-analytics-function-description\">\n    Count the number of times values are reported.\n</div>\n";;
var path = '/builds/observability/imm/signalview/src/legacy/app/analytics/block/COUNT/config.tpl.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;